// Loads the post of a post page, in the browser as well as when prerendering: only that post's
// module is imported (each post is its own chunk), found through the small slug → file index
// generated by vite.config.js. The full list of posts (#lib/posts.js) stays on the server.
import { error } from '@sveltejs/kit';
import { dev } from '$app/environment';
import postIndex from 'virtual:post-index';
import { toPost } from '#lib/post.js';

const postModules = import.meta.glob('/src/posts/*.{md,svx,svelte.md}');

const notFound = () => error(404, 'Oh no! The requested page could not be found.');

/** The post (view model + rendered `component`) for a slug, or a 404. */
export async function loadPostForSlug(slug) {
  const path = postIndex[slug];
  if (!path || !postModules[path]) notFound();
  const postModule = await postModules[path]();
  return { ...toPost(path, postModule.metadata), component: postModule.default };
}

/**
 * Same as loadPostForSlug, but drafts (`published: false`) are a 404 in the production build,
 * even when another page links to them: the prerender crawler would otherwise publish them.
 * They stay visible with `npm run dev` for proofreading.
 * (`future/` and `alternate-reality/` teaser pages are intentionally unpublished and keep using loadPostForSlug.)
 */
export async function loadPublishedPostForSlug(slug) {
  const post = await loadPostForSlug(slug);
  if (!post.metadata.published && !dev) notFound();
  return post;
}
